<template>
  <div class="m-grid__item m-grid__item--fluid m-wrapper">
    <div class="m-content">
      <div class="row">
        <div class="col-sm-4">
          <card @getCards="getCards"></card>
        </div>
        <div class="col-sm-8">
          <div class="m-portlet m-portlet__info m-portlet__border">
            <div class="m-portlet__head">
              <div class="m-portlet__head-caption">
                <div class="m-portlet__title">
                  Credit/Debit Cards
                </div>
              </div>
            </div>
            <div class="m-portlet__body">
              <spinner v-if="loading" message="Loading..."></spinner>
              <table v-else class="table table-striped table-bordered">
                <thead>
                  <th>Card Number</th>
                  <th>Dated Added</th>
                  <th>Action</th>
                </thead>
                <tbody>
                  <tr v-for="card in cards" :key="card.id">
                    <td>{{ card.cardNo }}</td>
                    <td>{{ card.addedOn }}</td>
                    <td>
                      <a class="btn btn-danger btn-sm m-btn m-btn--icon m-btn--icon-only m-btn--pill" href="javascript:void(0)" @click="removeCard(card.cardToken)">
                        <i class="fa fa-trash"></i>
                      </a>
                    </td>
                  </tr>
                  <tr v-if="cards.length === 0">
                    <td colspan="3">No cards added.</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "../../api";
import card from "./partial/Card";
import helper from "../../helpers";
import spinner from "vue-simple-spinner";

export default {
  name: "Billing",
  data() {
    return {
      cards: [],
      loading: false,
      token: this.$store.state.token || window.localStorage.getItem("token")
    };
  },
  components: {
    card,
    spinner
  },
  methods: {
    getCards() {
      const txType = "get-cards";
      this.toggleLoading();
      api
        .request(txType, { token: this.token })
        .then(response => {
          if (response.data.status === "00") {
            this.toggleLoading();
            this.cards = response.data.cards;
          } else {
            this.cards = [];
            this.toggleLoading();
            console.log(response.data);
          }
        })
        .catch(error => {
          this.toggleLoading();
          console.log(error);
        });
    },
    removeCard(cardToken) {
      helper
        .questionAlert("Are you sure you want to remove this card?", "Confirm")
        .then(() => {
          const txType = "remove-card";
          const data = {
            token: this.token,
            cardToken: cardToken
          };
          api
            .request(txType, data)
            .then(response => {
              if (response.data.status === "00") {
                helper
                  .successAlert("Card has been removed successfully")
                  .then(() => {
                    this.getCards();
                  });
              } else {
                helper.errorAlert(response.data.message);
              }
            })
            .catch(error => {
              helper.errorAlert("An error occured. Please try again later");
              console.log(error);
            });
        });
    },
    toggleLoading() {
      this.loading = this.loading ? false : true;
    }
  },
  created: function() {
    this.getCards();
  },
  mounted: function() {
    this.$store.commit("SET_SERVICES", null);
    if (window.localStorage) {
      window.localStorage.removeItem("services");
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/billing/Billing.vue